/**
 * .disable-on-submit
 * When an element with .disable-on-submit is clicked, this element is disabled when the form is submitted
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

;$(function(){

    "use strict";

    /**
     * Define selector
     *
     * @type {String}
     */
    var $selector =  '.disable-on-submit';

    /**
     * Define method as a property
     *
     * @return closure
     */
    var disableOnSubmit = function(){
        /* Locate the button */
        var button = $(this);
        /* Find the closest form and on its submit - disable out button */
        button.closest('form').submit(function(){
            // Disable
            button.addClass('disabled').prop('disabled', true);
            // Disable
            return true;
        })
    }

    /**
     * Inputs marked with "data-submit-on-change" attribute will trigger the form submit
     */
    $(document).on('click', $selector, disableOnSubmit);
});
